var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "device-phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1777 25.8228C26.2373 37.8823 29.7712 34.9965 31.3493 33.869C31.6045 33.7242 37.4458 29.9602 33.813 26.3282C25.3872 17.9017 27.0968 28.8543 19.1198 20.879C11.1447 12.9019 22.0983 14.6128 13.6725 6.18712C10.0393 2.55395 6.27492 8.39575 6.13173 8.6492C5.00277 10.2275 2.11807 13.7633 14.1777 25.8228Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a2682cf0cbff8f781dc946d631350a29.svg";
export { ForwardRef as ReactComponent };